






























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SignUp from '@/components/SignUp.vue';
import Login from '@/components/Login.vue';
import Modal from '@/components/Modal.vue';
import store from '@/store';
import { ALT_INFO_SITE, INFO_SITE } from '@/config';

type NAV_ITEM_TYPE = 'external_link' | 'link' | 'function';
interface INavItem {
  type: NAV_ITEM_TYPE;
  name: string;
  url?: string | (() => string);
  fn?: () => void;
  hide?: boolean;
}

@Component({
  components: {
    SignUp,
    Login,
    Modal,
  },
  data: () => ({
    INFO_SITE,
    ALT_INFO_SITE,
  }),
})
export default class Navbar extends Vue {
  public isActive = false;
  public showLoginModal = false;
  public showSignUpModal = false;
  public hasConnectionIssues = false;

  // get userItems(): INavItem[] {
  //   return [
  //     { type: 'link', name: 'Play Game', url: () => `/selectGame?mode=${this.loggedIn ? 'play' : 'watch'}` },
  //     { type: 'function', name: 'Log In', fn: this.showLogin, hide: this.loggedIn },
  //     { type: 'link', name: 'My Account', url: '/account', hide: !this.loggedIn },
  //     { type: 'external_link', name: 'Rules', url: `${INFO_SITE}/rules` },
  //     { type: 'external_link', name: 'Roster', url: `${INFO_SITE}/roster` },
  //     { type: 'external_link', name: 'Top 25', url: `${INFO_SITE}/top-25` },
  //     { type: 'external_link', name: 'FAQ', url: `${INFO_SITE}/FAQ` },
  //     { type: 'external_link', name: 'VFL Standings', url: `${INFO_SITE}/standings` },
  //   ];
  // }

  get userItems(): INavItem[] {
    return [
      { type: 'link', name: 'Watch Game', url: () => `/selectGame?mode=${this.loggedIn ? 'play' : 'watch'}` },
      // { type: 'external_link', name: 'Challenge', url: `${INFO_SITE}/challenge` },
      { type: 'external_link', name: 'Standings', url: `${INFO_SITE}/standings` },
      { type: 'external_link', name: 'Info', url: `${ALT_INFO_SITE}` },
      // { type: 'external_link', name: 'Learn More', url: `${INFO_SITE}/rules` },
      { type: 'function', name: 'Log In', fn: this.showLogin, hide: this.loggedIn },
      { type: 'link', name: 'My Account', url: '/account', hide: !this.loggedIn },
    ];
  }

  get adminItems(): INavItem[] {
    return [
      { type: 'link', name: 'Watch Game', url: '/selectGame?mode=watch' },
      { type: 'link', name: 'Manage Sessions', url: '/selectGame?mode=manage' },
      { type: 'link', name: 'Reporting', url: '/reports' },
    ];
  }

  @Prop({ required: false, type: Boolean, default: false})
  public adminMode!: boolean;

  public toggle() {
    this.isActive ? this.hide() : this.show();
  }
  public show() {
    this.isActive = true;
  }
  public hide() {
    this.isActive = false;
  }
  get loggedIn() {
    return store.getters['auth/authenticated'];
  }
  get navItems() {
    return (this.adminMode ? this.adminItems : this.userItems)
      .filter((item) => item && !item.hide);
  }

  public itemLink(item: INavItem) {
    return typeof item.url === 'function' ? item.url() : item.url;
  }

  public showSignUp() {
    this.showSignUpModal = true;
    return;
  }

  public showLogin() {
    this.showLoginModal = true;
    return;
  }

  @Watch('$route')
  public onRouteChange() {
    this.hide();
  }
}
